import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["fluid", "theme"];
const ContainerDiv = styled(Div).attrs(_ref => {
  let {
      fluid,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    mr: 'auto',
    ml: 'auto',
    pr: `${theme.grid.outerMargin}px`,
    pl: `${theme.grid.outerMargin}px`,
    width: `100%`,
    maxWidth: fluid ? `100%` : theme.breakpoints[3]
  }, props);
})``;
ContainerDiv.displayName = 'ContainerDiv';

const _excluded$1 = ["children", "styles"];
function Container(_ref) {
  let {
      children,
      styles = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/createElement(ContainerDiv, _extends({}, props, styles.root), children);
}

export default Container;
